import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import type { BreadcrumbItem } from './types'

interface BreadcrumbState {
  breadcrumbList: BreadcrumbItem[]
  setBreadcrumbList: (list: BreadcrumbItem[]) => void
}

export const useBreadcrumbStore = create<BreadcrumbState>()(
  immer((set) => ({
    breadcrumbList: [{ title: 'Главная', path: '/' }],
    setBreadcrumbList: (list) =>
      set((state) => {
        state.breadcrumbList = list
      }),
  })),
)
